import { appInfo } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              {appInfo.title}
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              {appInfo.desc}
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-3">
              {appInfo.features.map((f, idx) => (
                <span
                  key={idx}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50 border border-background-200/60 text-xs text-foreground-600"
                >
                  <i className="ri-check-line text-primary-500 text-sm" />
                  {f}
                </span>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-foreground-950 text-background-50 font-semibold text-sm hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill text-lg" />
                App Store 下载
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border-2 border-foreground-800 text-foreground-800 font-semibold text-sm hover:bg-foreground-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill text-lg" />
                Android 下载
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[400px] lg:max-w-none">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-300/20 via-accent-300/15 to-transparent rounded-2xl blur-xl" />
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20manga%20reading%20app%20interface%20with%20continuous%20vertical%20scroll%20design%2C%20Japanese%20comic%20style%20artwork%20on%20screen%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20clean%20modern%20UI%2C%20soft%20ambient%20lighting%2C%20editorial%20product%20photography%2C%20minimalist%20composition&width=600&height=700&seq=app-manga-mockup&orientation=portrait"
                alt="汗汗漫画APP移动端阅读体验"
                title="汗汗漫画APP下载"
                className="relative w-full h-auto rounded-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}